import React from 'react';
import { SectionHeading } from './SectionHeading';
const items = [{
  emoji: '📦',
  label: 'Cardboard',
  tone: 'bg-coral-light'
}, {
  emoji: '🧴',
  label: 'Bottles',
  tone: 'bg-sky-light'
}, {
  emoji: '✂️',
  label: 'Scissors',
  tone: 'bg-sunshine-light'
}, {
  emoji: '🖊️',
  label: 'Pens',
  tone: 'bg-brand-light'
}, {
  emoji: '🔧',
  label: 'Tape',
  tone: 'bg-mint-light'
}, {
  emoji: '🪩',
  label: 'Bottle caps',
  tone: 'bg-coral-light'
}];
export function Materials() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-106" data-mp="1geeuu42tb230">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-107" data-mp="1v5xi8my03ywe">
        <SectionHeading eyebrow="🛒 What you need" title={<>Just everyday things from home</>} subtitle="No robotics kits. No expensive parts. Just things you already have." data-id="element-108" data-mp="1qep9lt4hwhka" />
        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-6" data-id="element-109" data-mp="xq9t125ptr6u">
          {items.map(it => <div key={it.label} className={`flex flex-col items-center gap-3 rounded-2xl border border-ink/10 px-4 py-8 text-center ${it.tone}`} data-id="element-110" data-mp="10t97wh00cneo">
              <span className="text-4xl" aria-hidden="true" data-id="element-111" data-mp="1ajvks3gcazto">
                {it.emoji}
              </span>
              <span className="text-sm font-semibold text-ink" data-id="element-112" data-mp="1eknusyx1d8r0">{it.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}